export default "__VITE_ASSET__CU6Ejrfb__"